import { addMonetaryValues } from '../../../../utils/monetary-value-utils';
import { getOrderItemsTotalPrice } from '../items/get-order-items-total-price';
import { getOrderSubscriptionPrice } from '../subscriptions/get-order-subscription-price';
import { getOrderTicketsTotalPrice } from '../tickets/get-order-tickets-total-price';
/**
 * Gets the subtotal price of the order (excluding booking fee).
 */
export const getOrderSubtotalPrice = () => {
    const costOfItems = getOrderItemsTotalPrice();
    const costOfTickets = getOrderTicketsTotalPrice();
    const costOfSubscription = getOrderSubscriptionPrice();
    return addMonetaryValues(costOfItems, costOfTickets, costOfSubscription);
};
